<div *ngIf="!sharedDataSvc.isAdmin &&  sharedDataSvc.allListsLoaded && sharedDataSvc.profilLoaded">
    <div class="row">
        <div class="col-6 offset-3">
            <div class="card mt-5 bg-danger text-white">
                <div class="card-body d-flex flex-column align-items-stretch">
                    <div class="card-body d-flex align-items-center justify-content-around">
                        <div style="font-size:72px;">
                            <i class="fas fa-times-circle"></i>
                        </div>
                        <h3>Votre profil ne vous permet pas d'accéder à cet écran</h3>
                    </div>

                    <a href="#" class="my-3 text-center" (click)="sharedDataSvc.redirectToDefaultScreen()">
                        <h5>Retour à l'écran par défaut</h5>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>